import { motion, useReducedMotion } from "framer-motion";
import { Check } from "@phosphor-icons/react";
import { Kicker } from "./Kicker";
import { fadeIn } from "./fadeIn";

/** The future we want: the same-day, evidence-backed answer. */
const POINTS = [
  "The answer comes with evidence, including what the logs never recorded.",
  "Every action on a host has a record of who approved it.",
  "Every hunt becomes a check that keeps running, so next time is faster.",
  "Hunting is a weekly habit for a small team, not a quarterly project for a specialist.",
];

export function FutureSection() {
  const reduce = useReducedMotion();
  return (
    <section className="bg-card px-6 py-10 md:px-12 md:py-28" aria-labelledby="future-heading">
      <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[1fr_1fr] lg:items-start lg:gap-16">
        <motion.div {...fadeIn(reduce)} className="flex flex-col gap-4 md:gap-5">
          <Kicker>Where you want to be</Kicker>
          <h2 id="future-heading" className="heading-lg text-ink text-balance">
            When an advisory lands, you answer &ldquo;were we hit?&rdquo; the same day.
          </h2>
        </motion.div>
        <ul className="flex flex-col divide-y divide-rule border-y border-rule">
          {POINTS.map((p, i) => (
            <motion.li
              key={p}
              {...fadeIn(reduce, 0.06 * i)}
              className="flex gap-3 py-3 text-base leading-relaxed text-ink md:py-5 md:text-lg"
            >
              <Check
                size={20}
                weight="bold"
                className="mt-1 shrink-0 text-primary-500"
                aria-hidden
              />
              {p}
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
}
